module.exports = __webpack_public_path__ + "assets/img/product.065c37d0.png";